import { requestJson } from "../core/http.js";

export class ExplainClient {
  constructor(apiBase, request = requestJson) {
    this.apiBase = apiBase;
    this.request = request;
  }

  get available() {
    return Boolean(this.apiBase);
  }

  buildPayload(result, imageDataUrl, context = {}) {
    return {
      prediction: result.top.id,
      confidence: Number(result.confidence.toFixed(4)),
      uncertain: result.uncertain,
      probabilities: result.probabilities,
      image: imageDataUrl || null,
      source: context.source || "photo",
      language: "it"
    };
  }

  async explain(result, imageDataUrl, context) {
    if (!this.available) throw new Error("Spiegazione non configurata");
    const data = await this.request(`${this.apiBase}/api/explain`, {
      method: "POST",
      body: this.buildPayload(result, imageDataUrl, context),
      timeoutMs: 45000
    });
    if (!data?.text) throw new Error("Risposta vuota");
    return data;
  }
}
